import { render, staticRenderFns } from "./AsMainReceivedSubList.vue?vue&type=template&id=732e79eb"
import script from "./AsMainReceivedSubList.vue?vue&type=script&lang=js"
export * from "./AsMainReceivedSubList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports